var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"program view-container"},[_c('MainCard',{staticClass:"main-card",attrs:{"data":_vm.programData}}),_c('ProgramTab',{attrs:{"list":_vm.programList,"selected-program":_vm.selectedProgram}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }